<template>
  <div>
    <div id="main">
      <app-header></app-header>
      <thumbs></thumbs>
      <div class="toggle"></div>
    </div>
    <viewer></viewer>
  </div>
</template>

<script>
    import AppHeader from './gallery/AppHeader'
    import Thumbs from './gallery/Thumbs'
    import Viewer from './gallery/Viewer'
    import {EventBus} from './gallery/event_bus';

  export default {
    name: 'gallery',
      components: {
          AppHeader,
          Thumbs,
          Viewer
      },
      beforeCreate: function() {
          document.body.className = 'gallery';
      },
      created() {
        this.item = {'imgix_url': 'static/gallery/DSC_6067.jpg'};
        EventBus.$emit('loaded', this.item);
      },
      data () {
          return {
              item: {}
          }
      },
  }
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import '../assets/css/main.css'
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue?c968fc78